/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IStateService} from 'angular-ui-router';

declare let require: any;
declare let angular: any;

import IFormController = angular.IFormController;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;
import IComponentOptions = angular.IComponentOptions;
import ILogService = angular.ILogService;

let styles = require('./abschlussView.scss');
let template = require('./abschlussView.html');

export class AbschlussViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = AbschlussViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        titleText: '<',
        messageText: '<',
        buttonText: '<',
        stateToGoTo: '<',
    };
}

export class AbschlussViewController {

    form: IFormController;
    titleText: string;
    messageText: string;
    buttonText: string;
    stateToGoTo: string;

    static $inject = ['$scope', '$translate', '$log', '$state'];

    /* @ngInject */
    constructor($scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService) {

    }

    $onInit() {
        if (!this.titleText) {
            this.titleText = 'ABSCHLUSS_TITLE'
        }

        if (!this.messageText) {
            this.messageText = 'ABSCHLUSS_TEXT'
        }

        if (!this.buttonText) {
            this.buttonText = 'ABSCHLUSS_BUTTON_TEXT'
        }
        if (!this.stateToGoTo) {
            this.stateToGoTo = 'schadenfaelle';
        }
    }

    public getInfoTitle(): string {
        return this.$translate.instant(this.titleText)
    }

    public getInfoText(): string {
        return this.$translate.instant(this.messageText)
    }

    public getButtonText(): string {
        return this.$translate.instant(this.buttonText)

    }

    public navigate() {

        this.$state.go(this.stateToGoTo)

    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/abschlussView/abschlussView.ts